/* eslint-disable eqeqeq */
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import {  getIsDesktop } from '../../../utils/Utils';
import * as SDK from '@vkontakte/calls-sdk'
import BaseDesktopDialog from '../../../custom_views/BaseDesktopDialog';
import hand_down from '../../../img/call/hand_down.svg'
const HandUpDialog = ({isShow, setShow, stream}) => {
    const user = stream.user
    const user_info = stream.user_info
    const isDesktop = getIsDesktop()
    const handDown = async () => {
        setShow(false)
        await SDK.customData({"up" : "0", "can_speak" : "0"}, user.id)
    }
    const turnOnMic = async () => {
        setShow(false)
        await SDK.muteParticipant(user.id, {"AUDIO" : SDK.MuteState.MUTE})
        await SDK.customData({"up" : "0", "can_speak" : "1"}, user.id)
    }
    if (user == undefined){
        return null
    }
    const getInnerHtml = () => {
        return(
            <div className="call_info_container">
                <div style={{textAlign : 'left'}} className="call_more_title_dialog">{user_info.name + " " + user_info.surname}</div>
                <div onClick={handDown} className="call_more_btn_dialog hover">
                        <img style={{marginLeft : '1px'}} alt='' src={hand_down}/>
                        <div className="call_more_btn_text">Опустить руку</div> 
                    </div>
                <div onClick={turnOnMic} className="call_more_btn_dialog hover">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none">
                        <path d="M12.0002 2.48438C9.79105 2.48438 8.00019 4.27524 8.00019 6.48437V11.4844C8.00019 13.6935 9.79105 15.4844 12.0002 15.4844C14.2093 15.4844 16.0002 13.6935 16.0002 11.4844V6.48438C16.0002 4.27524 14.2093 2.48438 12.0002 2.48438Z" fill="#AC92ED"/>
                        <path d="M5.1003 12.4844C4.54896 12.4844 4.11844 12.97 4.2572 13.5036C5.07879 16.6629 7.78287 19.0629 11.1002 19.4343V21.5844C11.1002 22.0814 11.5031 22.4844 12.0002 22.4844C12.4972 22.4844 12.9002 22.0814 12.9002 21.5844V19.4343C16.2175 19.0629 18.9216 16.6629 19.7432 13.5036C19.8819 12.97 19.4514 12.4844 18.9001 12.4844C18.4504 12.4844 18.0742 12.8134 17.9467 13.2447C17.1881 15.8114 14.8129 17.6844 12.0002 17.6844C9.1875 17.6844 6.81226 15.8114 6.05363 13.2447C5.92617 12.8134 5.54999 12.4844 5.1003 12.4844Z" fill="#AC92ED"/>
                    </svg>
                    <div className="call_more_btn_text">Попросить вкл микрофон</div> 
                </div>
            </div>
        )
    }
    if (isDesktop){
        return(<BaseDesktopDialog isShow={isShow} setShow={setShow} getInnerHtml={getInnerHtml}/>)
    } else {
        return (
            <BottomSheet style={{zIndex : 9999}} onDismiss={() => setShow(false)} open={isShow}>
                {getInnerHtml()}
            </BottomSheet>
        )
    }
    
}

export default HandUpDialog;
